import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { SlotGames } from "../../../../lib/data/SlotGames.data";
import BackIcon from "../../../../assets/svg/BackIcon";

import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";

const Slots = () => {
  const categoriesTab = [
    { name: "NetEnt", key: "netent" },
    { name: "Red Tiger", key: "redTiger" },
    { name: "Jili", key: "jiliGames" },
    { name: "Playson", key: "playson" },
    { name: "Playtech", key: "playtech" },
    { name: "Pragmatic Play", key: "pragmaticPlayGames" },
    { name: "Spribe", key: "spribe" },
    { name: "InOut Games", key: "inout" },
    { name: "Big Time Gaming", key: "bigTimeGaming" },
    { name: "Golden Race", key: "goldenrace" },
    { name: "BetOnGames", key: "betongames" },
    // { name: "HP 100", key: "HP100" },
    { name: "Betsoft", key: "betsoft" },
    // { name: "Macaw Gaming", key: "macaw" },
    { name: "Caleta Gaming", key: "caletagaming" },
    { name: "TrueLab", key: "truelab" },
    { name: "BGaming", key: "BGaming" },
    { name: "Kalamba Games", key: "kalambagames" },
    { name: "Popok Gaming", key: "popokGaming" },
    { name: "PlayAce Gaming", key: "playaceGaming" },
    { name: "TV Bet", key: "tvbetGames" },
    { name: "Vivo Gaming", key: "vivoGaming" },
    { name: "Crash Games", key: "crashGames" },
    { name: "Mac88", key: "mac88Games" },
    { name: "Mac88VR", key: "mac88VRGames" },
    { name: "Asia Gaming", key: "asiaGamingGames" },
    { name: "Bet Games", key: "betGames" },
    { name: "Fishing Games", key: "fishingGames" },
    { name: "Pocket Games Soft", key: "PGSoftGames" },
    { name: "Hacksaw", key: "hacksawGames" },
    { name: "Turbo", key: "turboGames" },
    { name: "Play'n Go", key: "playNGoGames" },
    { name: "Relax Gaming", key: "relaxGamingGames" },
    { name: "Habanero", key: "habaneroGames" },
    { name: "Dragoon Soft", key: "dragoonSoftGames" },
    { name: "SmartSoft", key: "smartSoftGames" },
  ];
  const [activeCategory, setActiveCategory] = useState("netent");
  const [filteredData, setFilteredData] = useState([]);
  const [isSearched, setIsSearched] = useState(false);
  const navigate = useNavigate();
  const { categories } = useParams();
  console.log(categories, "categories")
  console.log(activeCategory, "activeCategory")

  useEffect(()=>{
    if (
      categories
    )
    {setActiveCategory (categories)}

  },[categories])



  return (
    <>
      <main className="main">
        <div className="">
          <HeaderAfterLogin />
        </div>
        <div className="home-section">
          
          <div className="right-section">
            
            <div className="container-fluid">
              <div className="casinoProvidersGames">
                <div className="pagesHeading">
                  <h2 className="sectionTitle border-0">Slots</h2>
                  <a className="back-link" href="/">
                    Back <BackIcon />
                  </a>
                </div>
                
                <ul className="tabs">
                  {categoriesTab.map((tab, index) => (
                    <li
                      key={index}
                      onClick={() => {
                        setFilteredData([]);
                        setIsSearched(false);

                        if (tab?.redirectUrl) {
                          navigate(tab?.redirectUrl);
                        } else {
                          setActiveCategory(tab.key);
                          navigate(`/slots/${tab.key}`)
                        }
                      }}
                      style={
                        activeCategory === tab.key
                          ? {
                              background: "#182838",
                            }
                          : {}
                      }
                    >
                      <a
                        href="#"
                        style={
                          activeCategory === tab.key
                            ? {
                                color: "#ecd35c;",
                              }
                            : {}
                        }
                      >
                        {tab.name}
                      </a>
                    </li>
                  ))}
                </ul>

                {!isSearched ? (
                  <ul className="games">
                    {Array.isArray(Object.values(SlotGames)) &&
                      Object.values(SlotGames)
                        .filter((f) => f?.key === activeCategory)
                        .map((slide) =>
                          Object.values(slide)
                            .filter((f) => typeof f !== "string")
                            .map((game) =>
                              Object.values(game).map((item, idx) => (
                                <li key={"casinogame" + idx}>
                                  <a
                                    className="play-button"
                                    href={item.redirectUrl}
                                  >
                                    <img
                                      // loading="lazy"
                                      src={item?.imgUrl?.startsWith("./")
                                          ? item.imgUrl.replace("./", "/")
                                          : item?.imgUrl}
                                      alt={item.name}
                                    />
                                    <div className="play-btn">
                                      <img
                                        src="/images/play-btn.png"
                                        alt="play"
                                      />
                                    </div>
                                    <div className="name">{item.name}</div>
                                  </a>
                                </li>
                              )),
                            ),
                        )}
                  </ul>
                ) : (
                  <ul className="games">
                    {filteredData.length > 0 &&
                      filteredData.map((game, idx) => (
                        <li key={"casinogame" + idx}>
                          <a className="play-button" href={game.redirectUrl}>
                            <img
                              loading="lazy"
                              src={game?.imgUrl?.startsWith("./")
                                ? game.imgUrl.replace("./", "/")
                                : game?.imgUrl}
                              alt={game.name}
                            />
                            <div className="play-btn">
                              <img
                                loading="lazy"
                                src="/images/play-btn.png"
                                alt="play"
                              />
                            </div>
                            <div className="name">{game.name}</div>
                          </a>
                        </li>
                      ))}
                  </ul>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Slots;
